import { Routes } from "@angular/router";
import { HomePageComponent } from "./components/home-page/home-page.component";
import { ScoreCardPageComponent } from "./components/score-card-page/score-card-page.component";
import { LookupsResolver } from "./resolvers/lookups.resolver";

export const routes: Routes = [
  { path: '', component: HomePageComponent, resolve: { lookups: LookupsResolver } },
  { path: 'scorecard', component: ScoreCardPageComponent},
  { path: '**', redirectTo: '' }
];